import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=d9dd7068&scoped=true"
import script from "./card-user.vue?vue&type=script&lang=js"
export * from "./card-user.vue?vue&type=script&lang=js"
import style0 from "./card-user.vue?vue&type=style&index=0&id=d9dd7068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dd7068",
  null
  
)

export default component.exports